namespace Core {
    enum PassengerType {
        Adult = 1,
        Child = 2
    }

    type Tax = {
        TotalAmount: number;
        CurrencyCode: string;
        EstabId: number;
    };

    type TaxList = Tax[];

    const ApiUrl: string = '/api/taxation/getCityTax';

    export interface TaxationService {
        getCityTax(tripId: string, basketId: string):ng.IPromise<Tax>;
        getCityTaxes(tripId: string, Estabs: object):ng.IPromise<TaxList>;
    }

    export class TaxationService implements TaxationService {
        constructor(
            private $q: ng.IQService,
            private $http: ng.IHttpService,
            private basketStore: any,
            private tripService
        ) {
        }


        getCityTax(tripId: string, basketId: string) {
            if(TRPCONFIG.Domain.EnableCityTax) {
                let EstabId;
                return this.$q.all([
                    this.basketStore.hotel(basketId),
                    this.basketStore.hotelCost(basketId)
                ]).then(results => {
                    const [hotelFromBasket, hotelCost] = results;
                    if(hotelFromBasket) {
                        EstabId = hotelFromBasket.Details.Itinerary.EstabId;
                        const Estabs = [
                            {
                                EstabId,
                                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                                TotalCost: hotelCost
                            }
                        ];
                        return this.getCityTaxes(tripId, Estabs);
                    } else {
                        return this.$q.when();
                    }
                }).then(res => _.find(
                    res,
                    (t:Tax) => t.EstabId === EstabId
                ));
             }
            else {
                 return this.$q.when();
             }
        }

        getCityTaxes(tripId, Estabs) {
            if(TRPCONFIG.Domain.EnableCityTax) {
                return this.$q.all([
                    this.tripService.getHotelsRequestCheckInDate(tripId, true),
                    this.tripService.getHotelsRequestCheckOutDate(tripId, true),
                    this.tripService.getTripOccupancy(tripId)
                ]).then(([ CheckInDate, CheckOutDate, occupancy ]) => {
                    return this.$http.post<Tax>(
                        ApiUrl, {
                            CheckInDate,
                            CheckOutDate,
                            Estabs,
                            Rooms: this.roomsFromOccupancy(occupancy)
                        }, {ignoreErrors: true}
                    );
                }).then(res => res.data);
            } else {
                return this.$q.when();
            }
        }

        private roomsFromOccupancy(occupancy:Core.Occupancy[]) {
            const defaultAdultAge = TRPCONFIG.Domain.MaximumChildAge + 1;
            return _.map(occupancy, (r:Core.Occupancy, i:number) => {
                let room:any = {};
                    room.RoomId = i+1; //A random roomId
                    let adults = _.fill(Array(r.Adults), {PassengerType: PassengerType.Adult, Age: defaultAdultAge});
                    let children = _.map(r.ChildAges ? r.ChildAges : [], a => {
                        return {
                            PassengerType: PassengerType.Child,
                            Age: a
                        };
                    });
                    room.Passengers = _.concat(adults, children);
                    return room;
            });
        }

    }
    angular.module('TR').service('taxationService', TaxationService);
}
